import { useEffect } from 'react';

import { q } from '@actual-app/core/shared/query';
import type { TransactionEntity } from '@actual-app/core/types/models';

import { avisarApunte } from '#components/mobile/avisos/avisosPush';
import { useMetadataPref } from '#hooks/useMetadataPref';
import { useQuery } from '#hooks/useQuery';

import { debeAvisar, guardarAvisado, leerAvisado } from './avisoPareja';
import { useTripulacion } from './useTripulacion';

/**
 * Pareja: cuando apuntas en un presupuesto compartido, avisa al servidor
 * para que la otra persona reciba «X ha apuntado un gasto» (si lo pidió).
 */
export function useAvisoPareja() {
  const [cloudFileId] = useMetadataPref('cloudFileId');
  const tripulantes = useTripulacion();
  const yo = tripulantes.find(p => p.esYo)?.userId ?? null;
  const compartido = Boolean(cloudFileId && yo && tripulantes.length > 1);

  const { data } = useQuery<Pick<TransactionEntity, 'id' | 'sort_order'>>(
    () =>
      compartido
        ? q('transactions')
            .filter({ autor: yo })
            .options({ splits: 'none' })
            .orderBy({ sort_order: 'desc' })
            .limit(1)
            .select(['id', 'sort_order'])
        : null,
    [compartido, yo],
  );
  const ultimo = data?.[0]?.sort_order ?? null;

  useEffect(() => {
    if (!compartido || !cloudFileId || ultimo == null) {
      return;
    }
    const avisado = leerAvisado(cloudFileId);
    if (debeAvisar(ultimo, avisado, Date.now())) {
      avisarApunte(cloudFileId);
    }
    if (avisado == null || ultimo > avisado) {
      guardarAvisado(cloudFileId, ultimo);
    }
  }, [compartido, cloudFileId, ultimo]);
}
